let _ = t => t,
    _t,
    _t2;

import { BATTLESHIP } from 'HubStyleTokens/colors';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
import styled from 'styled-components';
import H5 from 'UIComponents/elements/headings/H5';
import HR from 'UIComponents/elements/HR';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UIFlex from 'UIComponents/layout/UIFlex';
export const FlushedTitle = styled(H5).withConfig({
  displayName: "SharedComponents__FlushedTitle",
  componentId: "jc18h2-0"
})(["margin-bottom:0;"]);
export const CompactTitle = H5;
export const Divider = styled(HR).withConfig({
  displayName: "SharedComponents__Divider",
  componentId: "jc18h2-1"
})(["width:50px;margin:14px 0;color:", ";border-color:", ";background-color:", ";"], BATTLESHIP, BATTLESHIP, BATTLESHIP);
export const StyledStepperInput = styled(UIStepperInput).withConfig({
  displayName: "SharedComponents__StyledStepperInput",
  componentId: "jc18h2-2"
})(["display:inline-flex !important;max-width:100px;margin-right:8px;margin-left:8px;input{font-size:12px;height:34px;}"]);
export const StyledTitleContainer = styled.span.withConfig({
  displayName: "SharedComponents__StyledTitleContainer",
  componentId: "jc18h2-3"
})(["margin-bottom:8px;"]);
export const TitleContainer = styled(UIFlex).withConfig({
  displayName: "SharedComponents__TitleContainer",
  componentId: "jc18h2-4"
})(["", ""], breakpoint.phone(_t || (_t = _`
    flex-direction: column;
    align-items: start;
  `)));
export const SummaryColumnWrapper = styled.div.withConfig({
  displayName: "SharedComponents__SummaryColumnWrapper",
  componentId: "jc18h2-5"
})(["min-width:360px;position:sticky;", ""], breakpoint.tablet(_t2 || (_t2 = _`
    width: 100%;
  `)));